<template>
  <div>
    <div style="width: 100%;">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal')"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="limpiar()"
        />
      </div>
    </div>
    <ui-modal ref="modal" title="Filtros para tabla" size="large" @close="ActionSetZindexTablaModal(false) ">
      <div class="d-flex flex-column">
        <div class="d-flex">
          <div class="col-4">
            <label>Clientes</label>
            <ui-select
              class="w-100 mr-2"
              has-search
              placeholder="Seleccionar"
              :options="selectClients"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="filtroClientesModel">
            </ui-select>
          </div>
          <div class="col-4">
            <div class="w-100">
              <div style="color: grey; font-size: 15px">Naviera</div>
              <multiselect
                class="mt--1"
                placeholder="Seleccionar"
                :options="navieras"
                :searchable="true"
                v-model="filtroNavieraModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllNav" ref="checkAllNav" type="checkbox"
                           @change="seleccionarTodosNavieras($event, navieras);">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllNav">Seleccionar todo</label>
                  </div>
                </template>

              </multiselect>
            </div>
          </div>
          <div class="col-4">
            <!--          <ui-select-->
            <!--            class="w-100 ml-2"-->
            <!--            has-search-->
            <!--            label="Naviera Salida"-->
            <!--            placeholder="Seleccionar"-->
            <!--            searchPlaceholder="Buscar"-->
            <!--            multiple-->
            <!--            :options="dataListaNavierasNoUCC"-->
            <!--            :keys="{ value: 'id', label: 'name' }"-->
            <!--            v-model="filtroNavieraSalidaModel">-->
            <!--          </ui-select>-->

            <div class="w-100">
              <div style="color: grey; font-size: 15px">Naviera Salida</div>
              <multiselect
                placeholder="Seleccionar"
                :options="dataListaNavierasNoUCC"
                :searchable="true"
                v-model="filtroNavieraSalidaModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllNavSalida" ref="checkAllNavSalida" type="checkbox"
                           @change="seleccionarTodosNavierasSalida($event, dataListaNavierasNoUCC);">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllNavSalida">Seleccionar todo</label>
                  </div>
                </template>

              </multiselect>
            </div>
          </div>
        </div>
        <div class="d-flex mt-5">

          <!--          <ui-select-->
          <!--            class="w-100 mr-2"-->
          <!--            has-search-->
          <!--            label="Destino"-->
          <!--            placeholder="Seleccionar"-->
          <!--            multiple-->
          <!--            :keys="{ value: 'id', label: 'name' }"-->
          <!--            :options="destinos"-->
          <!--            @change="getPODByDestination()"-->
          <!--            searchPlaceholder="Buscar"-->
          <!--            v-model="filtroDestinoModel">-->
          <!--          </ui-select>-->
          <div class="col-4">
            <div class="w-100">
              <div style="color: grey; font-size: 15px">Destino</div>
              <multiselect
                class="mt--1"
                placeholder="Seleccionar"
                :options="destinos"
                :searchable="true"
                v-model="filtroDestinoModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
                @select="getPODByDestination()"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllDestino" ref="checkAllDestino" type="checkbox"
                           @change="seleccionarTodosDestino($event, destinos);getPODByDestination()">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllDestino">Seleccionar todo</label>
                  </div>
                </template>

              </multiselect>
            </div>
          </div>
          <div class="col-4">
            <!--            <label>POL</label>-->
            <!--            <ui-select-->
            <!--              class="w-100 mr-1 ml-1"-->
            <!--              has-search-->
            <!--              multiple-->
            <!--              :options="dataListaPOL"-->
            <!--              placeholder="Seleccionar"-->
            <!--              searchPlaceholder="Buscar"-->
            <!--              :keys="{ value: 'id', label: 'name' }"-->
            <!--              v-model="filtroPolModel">-->
            <!--            </ui-select>-->

            <div class="w-100">
              <div style="color: grey; font-size: 15px">POL</div>
              <multiselect
                class="mt--1"
                placeholder="Seleccionar"
                :options="dataListaPOL"
                :searchable="true"
                v-model="filtroPolModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllPOL" ref="checkAllPOL" type="checkbox"
                           @change="seleccionarTodosPOL($event, dataListaPOL);">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllPOL">Seleccionar todo</label>
                  </div>
                </template>

              </multiselect>
            </div>
          </div>
          <div class="col-4">
            <!--            <label>POD</label>-->
            <!--            <ui-select-->
            <!--              class="w-100 ml-2"-->
            <!--              has-search-->
            <!--              multiple-->
            <!--              placeholder="Seleccionar"-->
            <!--              searchPlaceholder="Buscar"-->
            <!--              :options="filtroDestinoModel.length === 0 ? dataListaPOD : podListByDestination"-->
            <!--              :disabled="podListDisabled"-->
            <!--              :keys="{ value: 'id', label: 'name' }"-->
            <!--              v-model="filtroPodModel">-->
            <!--            </ui-select>-->

            <div style="color: grey; font-size: 15px">POD</div>
            <multiselect
              class="mt--1"
              placeholder="Seleccionar"
              :options="filtroDestinoModel.length === 0 ? dataListaPOD : podListByDestination"
              :searchable="true"
              v-model="filtroPodModel"
              :disabled="podListDisabled"
              :multiple="true"
              label="name"
              track-by="name"
              :limit="1"
              :limitText=" count => `+ ${count} registros` "
              selectLabel="Agregar"
              deselectLabel="Quitar"
              selectedLabel="Agregado"
              :close-on-select="false"
            >
              <template slot="beforeList">
                <div class="d-flex align-items-center ml-2 selectAll">
                  <input id="checkAllPOD" ref="checkAllPOD" type="checkbox"
                         @change="seleccionarTodosPOD($event, filtroDestinoModel.length === 0 ? dataListaPOD : podListByDestination);">
                  <label class="mt-2 ml-2" style="width:100%" for="checkAllPOD">Seleccionar todo</label>
                </div>
              </template>

            </multiselect>
          </div>
        </div>
        <div class="d-flex mt-5">
          <date-picker
            class="w-100 mr-2"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Desde"
            v-model="filtroDesdeModel" />
          <date-picker
            class="w-100 mr-1 ml-1"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Hasta"
            v-model="filtroHastaModel" />
          <div class="w-100 ml-2">
            <ui-switch @change="busquedaEspecificaChange()" v-model="busquedaEspecifica">Búsqueda Fecha Específica
            </ui-switch>
          </div>
        </div>
        <div class="d-flex mt-5">
          <div class="col-4">
            <label>Vigencia</label>
            <date-picker
              class="w-100 mr-2"
              style="margin-left: -2px; font-size: 22px"
              type="date"
              value-type="format"
              :keys="{ value: 'id', label: 'name' }"
              @close="handleOpenChange"
              placeholder="Vigencia"
              v-model="filtroVigenciaModel"
            />
          </div>
          <div class="col-4">

<!--            <ui-select-->
<!--              class="w-100 mr-1 ml-1"-->
<!--              has-search-->
<!--              label="Producto"-->
<!--              placeholder="Seleccionar"-->
<!--              :keys="{ value: 'id', label: 'name' }"-->
<!--              multiple-->
<!--              searchPlaceholder="Buscar"-->
<!--              :options="commodity"-->
<!--              v-model="filtroProductoModel">-->
<!--            </ui-select>-->

            <div style="color: grey; font-size: 15px">Producto</div>
            <multiselect
              class="mt--1"
              placeholder="Seleccionar"
              :options="commodity"
              :searchable="true"
              v-model="filtroProductoModel"
              :multiple="true"
              label="name"
              track-by="name"
              :limit="1"
              :limitText=" count => `+ ${count} registros` "
              selectLabel="Agregar"
              deselectLabel="Quitar"
              selectedLabel="Agregado"
              :close-on-select="false"
            >
              <template slot="beforeList">
                <div class="d-flex align-items-center ml-2 selectAll">
                  <input id="checkAllProductos" ref="checkAllProductos" type="checkbox"
                         @change="seleccionarTodosProductos($event, commodity);">
                  <label class="mt-2 ml-2" style="width:100%" for="checkAllProductos">Seleccionar todo</label>
                </div>
              </template>

            </multiselect>
          </div>
          <div class="col-4">
            <label>Tipo contenedor</label>
            <ui-select
              class="w-100 ml-2"
              has-search
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'code'  }"
              v-model="filtroTipoContenedorModel"
              :options="contenedores">
            </ui-select>
          </div>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Tipo contrato"
            placeholder="Seleccionar"
            :options="tipoContratos"
            :keys="{ value: 'id', label: 'name' }"
            @change="searchContracts();"
            searchPlaceholder="Buscar"
            v-model="filtroTipoContratoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Contrato"
            placeholder="Seleccionar"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            :options="contracts"
            v-model="filtroContratoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Estado"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="estados"
            :keys="{ label: 'name', value: 'id' }"
            v-model="filtroEstadoModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
         

          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              label="Get Out"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="filtroGetOutModel"
              :options="[
                {id: 1, name: 'Si'},
                {id: 0, name: 'No'}
                ]">
            </ui-select>
          </div>

          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              label="Trat. frío"
              placeholder="Seleccionar"
              :keys="{ value: 'id', label: 'name' }"
              searchPlaceholder="Buscar"
              :options="coldtreatmentList"
              v-model="filtroColdtreatmentModel">
            </ui-select>
          </div>

          <div class="col-4">
            <ui-textbox
              type  = "number"
              class = "w-100 "
              floating-label
              v-model="tariff_line_id"
              label = "ID Tariff Line"
            />
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button class="btn btn-outline-secondary" @click="resetForm()" style="margin-right: 15px">
            Limpiar
          </button>
          <button class="btn btn-outline-primary" id="buttonRef" @click="filtrar()">Filtrar</button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";
import UiSwitch from "keen-ui/src/UiSwitch";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

import Button from "../../../common/Button";
import { mapActions, mapState } from "vuex";
import {
  getAcuerdosClientesBaseFiltro,
  getContratosPorNavieraYTipo,
  getClients,
  getPODByDestination,
  getListasAcuerdosBase
} from "../../../../constants/lineas";
import Multiselect from "vue-multiselect";

export default {
  props: ["getListaAcuerdosClientesBase"],

  computed: {
    ...mapState([
      "contratos", "navieras", "puertos",
      "destinos", "commodity", "tipoContratos",
      "contenedores", "estados", ""
    ]),
    ...mapState("lineas", [
      "dataListaPOD",
      "dataListaNaviera",
      "dataListaPOL",
      "dataListaProducto",
      "dataListaDestinos",
      "dataContenedores",
      "dataListaNavierasNoUCC"
    ])

  },
  data() {
    return {
      filtroClientesModel: {},
      filtroNavieraModel: [],
      filtroNavieraSalidaModel: [],
      filtroPolModel: [],
      filtroPodModel: [],
      filtroDestinoModel: [],
      filtroProductoModel: [],
      filtroDesdeModel: "",
      filtroHastaModel: "",
      filtroVigenciaModel: "",
      filtroTipoContratoModel: {},
      filtroContratoModel: {},
      filtroColdtreatmentModel: {},
      coldtreatmentList: [],
      filtroTipoContenedorModel: {},
      filtroEstadoModel: {},
      filtroBusquedaEspecificaDesdeModel: "",
      filtroBusquedaEspecificaHastaModel: "",
      filtroGetOutModel: "",
      contracts: [],
      busquedaEspecifica: false,
      selectClients: [{ id: 0, name: "" }],
      podListByDestination: [],
      podListDisabled: false,
      tariff_line_id: "",
    };
  },
  components: {
    UiSelect,
    Button,
    UiModal,
    DatePicker,
    UiSwitch,
    Multiselect
  },
  methods: {
    ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase", "actionSetFilterStateAcuerdosClientesBase"]),
    ...mapActions(["ActionSetShowAcuerdoLineasClienteBase", "ActionSetZindexTablaModal"]),

    seleccionarTodosNavieras(event, options) {

      if (event.target.checked) {

        this.filtroNavieraModel = options;

      } else {

        this.filtroNavieraModel = "";

      }
    },

    seleccionarTodosNavierasSalida(event, options) {

      if (event.target.checked) {

        this.filtroNavieraSalidaModel = options;

      } else {

        this.filtroNavieraSalidaModel = "";

      }
    },

    seleccionarTodosDestino(event, options) {

      if (event.target.checked) {

        this.filtroDestinoModel = options;

      } else {

        this.filtroDestinoModel = "";

      }
    },

    seleccionarTodosPOL(event, options) {

      if (event.target.checked) {

        this.filtroPolModel = options;

      } else {

        this.filtroPolModel = "";

      }
    },

    seleccionarTodosPOD(event, options) {

      if (event.target.checked) {

        this.filtroPodModel = options;

      } else {

        this.filtroPodModel = "";

      }
    },

    seleccionarTodosProductos(event, options) {

      if (event.target.checked) {

        this.filtroProductoModel = options;

      } else {

        this.filtroProductoModel = "";

      }
    },

    async getPODByDestination() {

      if (this.filtroDestinoModel.length >= 1) {

        this.podListDisabled = true;

        this.filtroPodModel = [];

        this.podListByDestination = await getPODByDestination({ "destinations": this.filtroDestinoModel.map(p => +p.id) ?? [] });

        this.podListDisabled = false;

      }
    },

    openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    busquedaEspecificaChange() {

      if (this.busquedaEspecifica) {
        this.filtroBusquedaEspecificaHastaModel = this.filtroHastaModel;
        this.filtroBusquedaEspecificaDesdeModel = this.filtroDesdeModel;
      } else {
        this.filtroBusquedaEspecificaHastaModel = "";
        this.filtroBusquedaEspecificaDesdeModel = "";
      }
    },
    async limpiar() {
      this.resetForm();

      this.$vToastify.loader("Recargando Tabla...");

      await this.getListaAcuerdosClientesBase();
      this.ActionSetShowAcuerdoLineasClienteBase(false);

      this.$vToastify.stopLoader();
    },
    resetForm() {
      this.filtroClientesModel = "";
      this.filtroNavieraModel = [];
      this.$refs.checkAllNav.checked = false;
      this.filtroNavieraSalidaModel = [];
      this.$refs.checkAllNavSalida.checked = false;
      this.filtroPolModel = [];
      this.$refs.checkAllPOL.checked = false;
      this.filtroPodModel = [];
      this.$refs.checkAllPOD.checked = false;
      this.podListByDestination = [];
      this.filtroDestinoModel = [];
      this.$refs.checkAllDestino.checked = false;
      this.filtroProductoModel = [];
      this.$refs.checkAllProductos.checked = false;
      this.filtroDesdeModel = "";
      this.filtroHastaModel = "";
      this.filtroVigenciaModel = "";
      this.filtroTipoContratoModel = {};
      this.filtroContratoModel = {};
      this.filtroColdtreatmentModel = {};
      this.filtroTipoContenedorModel = {};
      this.filtroEstadoModel = {};
      this.filtroBusquedaEspecificaHastaModel = "";
      this.filtroBusquedaEspecificaDesdeModel = "";
      this.contracts = [];
      this.filtroGetOutModel = "";
      this.tariff_line_id = "";
      this.actionSetFilterStateAcuerdosClientesBase(null);
    },
    async searchContracts() {

      const form = { type: +this.filtroTipoContratoModel.id };

      this.contracts = await getContratosPorNavieraYTipo(form);
    },
    async filtrar() {

      this.ActionSetShowAcuerdoLineasClienteBase(true);

      const coldtreatmentId =
        typeof this.filtroColdtreatmentModel === "object"
          ? (this.filtroColdtreatmentModel.id ?? "")
          : (this.filtroColdtreatmentModel ?? "");

      const form = {
        client_id: this.filtroClientesModel.id ?? "",
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.map(d => +d.id) ?? [],
        products_category_id: this.filtroProductoModel.map(p => +p.id) ?? [],
        from_date: this.filtroDesdeModel,
        to_date: this.filtroHastaModel,
        vigencia: this.filtroVigenciaModel,
        tipo_contrato: this.filtroTipoContratoModel.id ?? "",
        tariff_contract_id: this.filtroContratoModel.id ?? "",
        coldtreatment_id: coldtreatmentId,
        container_id: this.filtroTipoContenedorModel.id ?? "",
        estado: this.filtroEstadoModel.id ?? "",
        from_date_specific: this.filtroBusquedaEspecificaDesdeModel ?? "",
        to_date_specific: this.filtroBusquedaEspecificaHastaModel ?? "",
        get_out: this.filtroGetOutModel.id ?? null ,
        tariff_line_id: !this.tariff_line_id ? null : this.tariff_line_id,
      };

      this.estadoButton("Filtrando...");

      this.$vToastify.loader("Filtrando...");

      this.actionSetFilterStateAcuerdosClientesBase(form);

      if (
        form.client_id === ""
        && form.naviera_id === []
        && form.naviera_salida_id === []
        && form.pol === []
        && form.pod === []
        && form.destination_id === []
        && form.products_category_id === []
        && form.from_date === ""
        && form.to_date === ""
        && form.vigencia === ""
        && form.tipo_contrato === ""
        && form.tariff_contract_id === ""
        && form.coldtreatment_id === ""
        && form.container_id === ""
        && form.estado === ""
        && form.from_date_specific === ""
        && form.to_date_specific === ""
        && form.get_out === ""
      ) {

        this.ActionSetShowAcuerdoLineasClienteBase(false);

      } else {

        this.ActionSetShowAcuerdoLineasClienteBase(true);

      }

      try {

        const { data_table } = await getAcuerdosClientesBaseFiltro(form);

        this.actionSetDataListarTarifasAcuerdosClientesBase(data_table);

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        this.closeModal("modal");

      } catch (error) {

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        return this.$vToastify.error("Hubo un problema al filtrar datos, recargue la página y vuelva a intentar.", "Lo sentimos");

      }
    }
  },
  async created() {
    const { data } = await getClients();
    this.selectClients = data;
    const { lista_coldtreatment } = await getListasAcuerdosBase();
    this.coldtreatmentList = lista_coldtreatment || [];
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}

.selectAll > [type="checkbox"] {
  width: 18px;
  height: 18px;
}

.selectAll :hover {
  cursor: pointer;
}

.multiselect__tags {
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-size: 16px !important;
  padding: 4px 40px 0 8px !important;
  min-height: 32px;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px;
}

</style>
